class Countdown {
  constructor(options) {
    const { duration, onTick, onComplete } = options;
    this.duration = duration;
    this.initialDuration = duration;
    this.onTick = onTick;
    this.onComplete = onComplete;
    this.timer = null;
  }

  reset() {
    this.duration = this.initialDuration;
  }

  start() {
    if (this.timer) {
      return;
    }

    this.reset();
    this.tick(true);
    this.timer = setInterval(() => {
      this.tick();
    }, 1000);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  tick(isInit) {
    !isInit && this.duration--;
    if (this.duration >= 0) {
      if (this.onTick) {
        const formattedDuration = this.formatDuration(this.duration);
        this.onTick(formattedDuration, this.duration);
      }
    } else {
      this.stop();
      if (this.onComplete) {
        this.onComplete();
      }
    }
  }

  formatDuration(duration) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;

    let formattedTime = '';

    if (hours > 0) {
      const formattedHours = String(hours).padStart(2, '0');
      formattedTime += `${formattedHours}:`;
    }

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    formattedTime += `${formattedMinutes}:${formattedSeconds}`;

    return formattedTime;
  }
}

export default Countdown;
